import styles from './privacyPolicy.module.css';

const PrivacyPolicy = () => (
  <div className={styles.privacyPolicyContainer}>
    <div className={styles.company}>リンクティビティ株式会社</div>
    <h1>プライバシーポリシー</h1>

    <h2>個人情報保護方針</h2>
    <p>
      当社は、当社の運営する予約サイトLINKTIVITY等において、お客様から個人情報を取得しております。当社は、お客様が安心かつ便利に予約ができるようにするために、お客様の個人情報を保護することは非常に重要なことであると考えており、以下に記載する事項を遵守して個人情報を取り扱っております。
    </p>

    <h3>お客様の個人データの管理者</h3>
    <p>
      リンクティビティ株式会社
      <br />
      〒101-0053 東京都千代田区神田美土代町1番地 住友商事美土代ビル9階
    </p>

    <h3>取得の場面</h3>
    <p>
      当社は、法令により必要とされる場合にはお客様から同意を得た上で、当社の利用目的の達成に必要最⼩限の個人情報を取得します。
    </p>

    <h3>利用の場面</h3>
    <p>
      当社は、当社の定める利用目的の達成のためにのみ、お客様から取得した個人情報を利用いたします。
    </p>

    <h3>保管・保存の場面</h3>
    <p>
      当社は、お客様から取得した個人情報が外部に漏洩することのないよう、システムセキュリティに留意して個人情報の保管・保存等を行っています。
    </p>

    <h3>破棄・消去の場面</h3>
    <p>
      当社は、利用する必要がなくなった個人データ(個人情報の保護に関する法律に定める個人データを意味します。以下同じです。)は、必要がなくなった時点で、遅滞なく破棄します。
    </p>

    <h3>お客様からのお問い合わせ等への対応</h3>
    <p>
      当社は、お客様からの保有個人データ(個人情報の保護に関する法律に定める保有個人データを意味します。以下同じです。)の利用目的の通知の求め、開示請求、訂正・追加・削除請求、利用停止・消去請求及び第三者提供の停止請求に対し、法令に従い対応いたします。
    </p>

    <h3>安全管理措置等</h3>
    <p>
      当社は、LINKTIVITYサービスに関係する全てのスタッフが、個人情報の重要性を理解できるよう教育を行うほか、個人情報の安全管理のために必要かつ適切な措置を講じています。
    </p>

    <h2>目次</h2>
    <ol>
      <li>当社が取得する個人情報と利用目的について</li>
      <li>個人データの第三者提供について</li>
      <li>個人データの取扱の委託について</li>
      <li>Cookie情報等の取得について</li>
      <li>匿名加工情報の取扱いについて</li>
      <li>個人データの安全管理措置について</li>
      <li>お客様の個人データの取扱いに関する権利について</li>
      <li>開示・訂正・利用停止等の請求等について</li>
      <li>外部へのリンクについて</li>
      <li>プライバシーポリシーの変更について</li>
      <li>連絡先について</li>
    </ol>

    <h3>1. 当社が取得する個人情報と利用目的について</h3>
    <p>
      当社は、以下に掲げる利用目的で、お客様のご住所、ご氏名、生年月日、ご連絡先、メールアドレス又は旅券番号等の個人情報を取得し、利用いたします。また、当社は、お客様の同意なく要配慮個人情報を取得いたしません。なお、お客様の個人情報の取得にあたっては、個人情報の利用目的が公表されていない場合には、かかる取得の対象となった個人情報の利用目的を、お客様に通知し、又は公表するものとします。また、当社は、保護者の同意なく13歳以下の児童から個人情報を取得しません。13歳以下の児童の個人情報を提供いただく場合、保護者の同意を取得いただいているものとして取り扱いますが、同意がないことが明らかになった場合には、保護者への連絡その他に付随する目的以外に当該個人情報を利用しません。
    </p>
    <ol>
      <li>
        <b>LINKTIVITYサービス利用(会員登録等)のため</b>
        <br />
        LINKTIVITYサービス利用のため、お客様の個人情報を当社内部で共有します。
        <br />
        法的根拠：お客様の要求するサービスや機能を提供するために必要となります。
      </li>
      <li>
        <b>チケット購入のお申込みのため</b>
        <ul>
          <li>
            取得する個人情報の項目
            <br />
            当社は、お客様からの商品提供者からのチケット購入の申込み等に際して、お客様のご氏名、決済情報、旅券番号のほか、健康状態や病歴等といったお客様の健康状態に関する情報等を取得いたします。
          </li>
          <li>
            具体的な利用目的
            <br />
            当社は、お客様の商品提供者からのチケット購入資格の確認やチケットの代金等の決済のためにお客様の個人情報を取得し、利用いたします。また、かかる目的のために、商品提供者、交通機関、代金決済事業者等(海外の事業者等を含みます。)へお客様の個人情報を提供いたします。
          </li>
        </ul>
        法的根拠：お客様の要求するサービスや機能を提供するために必要となります。
      </li>
      <li>
        <b>ニュースレター(メールマガジン等)の送付等、各種ご案内の送付のため</b>
        <br />
        法的根拠：お客様の同意に基づき収集します。
      </li>
      <li>
        <b>ソーシャルメディアや広告配信プラットフォームを通じた広告のため</b>
        <br />
        法的根拠：お客様の同意に基づき収集します。
      </li>
      <li>
        <b>アンケートへのご記入のお願いのため</b>
        <br />
        法的根拠：当社の予約サイト、商品やサービス等の改善のためお客様の同意に基づき収集します。
      </li>
      <li>
        <b>お客様情報の解析及び管理のため</b>
        <br />
        法的根拠：当社の予約サイト、商品やサービス等の改善することにより、お客様の正当な利益を追求・保護するために必要となります。
      </li>
      <li>
        <b>クレジットカード等の不正利用の検知のため</b>
        <br />
        法的根拠：お客様のクレジットカードの安全性を確保し、お客様の正当な利益を追求するために必要となります。
      </li>
    </ol>

    <h3>2. 個人データの第三者提供について</h3>
    <p>
      当社は、以下のいずれかの場合を除き、お客様から取得した個人データを第三者に提供いたしません。
    </p>
    <ol>
      <li>
        お客様が第三者(商品提供者、海外の旅行業者、ソーシャルメディア事業者、広告配信サービス会社等の事業者を含みます。)への個人データの提供について、本プライバシーポリシーに同意いただく方法その他の方法により、事前にご同意をいただいた場合
      </li>
      <li>
        上記の利用目的の達成に必要な範囲内において個人データの取扱を外部委託した場合
      </li>
      <li>法令に基づき要求される場合</li>
      <li>
        人の生命、身体又は財産の保護のために必要な場合であって、お客様の同意を得ることが困難である場合
      </li>
      <li>
        公衆衛生の向上または児童の健全な育成のために特に必要がある場合であって、お客様の同意を得ることが困難である場合
      </li>
      <li>
        国又は地方公共団体などが法令に定める事務を実施する上で、協力する必要がある場合であって、お客様の同意を得ることにより当該事務の遂行に支障を及ぼすおそれがある場合
      </li>
    </ol>

    <h3>3. 個人データの取扱の委託について</h3>
    <p>
      当社は、前項に基づき当社の利用目的の達成に必要な範囲内で第三者にお客様の個人データの取扱いを委託する場合、委託先に対して必要かつ適切な監督を行います。また、委託先が再委託を行う場合には、当社は、委託先が再委託先に対して、必要かつ適切な監督を行っているか否かを直接又は間接に監督いたします。再委託先が再々委託する場合についても同様とします。
    </p>

    <h3>4. Cookie情報等の取得について</h3>
    <ol>
      <li>
        <b>クッキー(Cookie)</b>
        <p>
          クッキーとは、お客様(ユーザー)についての情報を含む、ユーザーのハードドライブに蓄えられるデータのひとつです。当社では、クッキーを、個人を特定する情報として利用することはありません。また、セッションクッキーですので、一旦ユーザーがそのブラウザを閉じますと、クッキーは保存されません。クッキーは、お客様へのサービス向上、当社サイトのカスタマイズ・広告の効果の測定等の目的で利用します。
        </p>
        <p>
          また、当社は、統計処理データとしてクッキーを分析することによって、お客様のご興味やご関心の高い事項を探知し、それらを活用しているほか、不正アクセス防止のためにも利用しております。
        </p>
        <p>
          クッキーは、お客様のご希望に応じて無効化することができますが、それにより、お客様はLINKTIVITYでのご予約ができなくなります。
        </p>
      </li>
      <li>
        <b>ログ・ファイル</b>
        <p>
          当社では、特定の情報を自動的に収集してログ・ファイルに保存しています。その特定の情報には、IP(インターネットプロトコル)アドレス、ブラウザの種類、ISP(インターネットサービスプロバイダ)、参照/終了ページ、オペレーティングシステム、日付/タイムスタンプが含まれます。当社は、これらの情報を、不正アクセスを監視する目的で利用しております。また、当社は、お客様の傾向分析や、サイト管理、サイトにおけるお客様の動向追跡を行っています。ただし、当社は、これらの情報を、特定の個人を識別できないようにして利用しており、取得した情報を上記以外の目的で利用することはありません。
        </p>
      </li>
      <li>
        <b>ウェブビーコンについて</b>
        <p>
          当社では、ウェブビーコンを、アクセス解析及びアフィリエイトプログラムのために利用しています。当社は、ウェブビーコンについて、上記以外の目的での利用や、特定の個人を識別するための利用はしておりません。
        </p>
      </li>
      <li>
        <b>統計的分析について</b>
        <p>
          当社では、どのサイトやサービスの人気が高いかを確認するために、第三者アクセス解析ツールを利用し、LINKTIVITYサイト内でお客様がアクセスしたページや、ページの履歴を記録しています。
        </p>
        <p>
          当社は、これらのデータを、特定の分野にご興味を示されたお客様に対して、LINKTIVITY内で、その興味に合わせたコンテンツや広告を提供するために使用しています。また、個人を特定しない統計情報を収集することもあります。さらに、第三者アクセス解析ツールにて当社が収集したクッキー情報と他社が収集したクッキー情報を双方で閲覧可能にすることもあります。
        </p>
      </li>
    </ol>

    <h3>5. 匿名加工情報の取扱いについて</h3>
    <ol>
      <li>
        <b>匿名加工情報の作成</b>
        <p>
          当社は、匿名加工情報を作成する場合には、以下の対応を行います。
          <br />
          匿名加工情報とは、法令の定めによる措置を講じて特定の個人を識別することができないように個人情報を加工して得られる個人に関する情報であって、当該個人情報を復元することができないようにしたものをいいます。
        </p>
        <ul>
          <li>法令で定める基準に従い、適正に加工すること</li>
          <li>
            法令で定める基準に従い、削除した情報や加工の方法に関する情報の漏えいを防止するために安全管理措置を講じること
          </li>
          <li>作成した匿名加工情報に含まれる情報の項目を公表すること</li>
          <li>
            作成に用いられた個人情報に係る本人を識別するための行為をしないこと
          </li>
        </ul>
      </li>
      <li>
        <b>匿名加工情報の提供</b>
        <p>
          匿名加工情報を第三者に提供する場合には、提供しようとする匿名加工情報に含まれる個人に関する情報の項目と提供の方法を公表するとともに、提供先となる第三者に対して、提供する情報が匿名加工情報であることを明示します。
        </p>
      </li>
      <li>
        <b>匿名加工情報に関する公表</b>
        <ul>
          <li>
            匿名加工情報の作成について
            <br />
            当社が保有する以下のお客様の個人情報について、当社は、特定の個人を識別すること及び個人情報を復元することができないよう適切な措置を講じたうえで匿名加工情報として継続的に作成いたします。
          </li>
          <li>
            匿名加工情報に含まれる個人に関する情報の項目
            <br />
            プラットフォームサービスの提供に関して取得した情報
            <br />
            購入日、参加日、バウチャーの言語、販売金額のレジ、参加人数、予約の状態(予約確定かキャンセル等)、サプライヤーの所在地地域及び県情報、旅行会社の所在国
          </li>
          <li>
            匿名加工情報の第三者提供について
            <br />
            当社が作成または保有する匿名加工情報について、当該情報が匿名加工情報であることを明示したうえで、継続的に第三者に提供いたします。
          </li>
          <li>
            匿名加工情報に含まれる個人に関する情報の項目
            <br />
            上記「匿名加工情報の作成について」における「匿名加工情報に含まれる個人に関する情報の項目」と同一の項目
          </li>
          <li>
            提供の方法
            <br />
            パスワードにより保護された電子ファイルを電子的な通信手段(電子メール、サーバーにアップロード、API連携等)、またはDVD等の物理媒体により送付
          </li>
        </ul>
      </li>
    </ol>

    <h3>6. 個人データの安全管理措置について</h3>
    <p>
      個人データの漏えい、盗用、悪用、不正アクセス、改ざん及び破壊等を防ぐために、組織的、技術的、物理的な安全管理措置を講じています。当社が個人データを保存するサーバーへのアクセスは、ID／PWを有する特定の従業員のみに制限されており、中でも一部の個人データの管理については、データの管理等に必要最小限の従業員にのみアクセスを付与しています。更にクレジットカード情報を含む個人データについては、複数のデータセンターに分散してセキュアな環境において保管しています。また、当社は、予約取引に関するすべてのページでSecure
      Sockets
      Layer(SSL)暗号を使用しています。SSL対応ブラウザの使用により、インターネットで送信する個人データとクレジットカード情報の機密性を保持することができます。また、お客様の個人データを取り扱う当社の従業員は、端末を離れるときにはパスワードで保護されたスクリーンセーバーを使用しております。さらに、当社は、部署によっては毎月1回、全社的には半年に1回以上の頻度で、個人情報の重要性等に関する教育研修を実施しております。また、教育に関する記録もとっております。
    </p>

    <h2>7. お客様の個人データの取扱いに関する権利について</h2>
    <p>
      2016年4月27日付のEU一般データ保護規則(GDPR)2016/679に基づき、個人データの処理に関し、お客様は以下の権利があります。
    </p>
    <ol>
      <li>アクセス権</li>
      <li>訂正権</li>
      <li>削除権(忘れられる権利)と処理を制限する権利</li>
      <li>データポータビリティー権</li>
      <li>異議を述べる権利</li>
      <li>プロファイリングを含む自動処理に基づく決定に服されない権利</li>
    </ol>

    <h3>8. 開示・訂正・利用停止等の請求等について</h3>
    <p>
      当社は、お客様からの保有個人データの利用目的通知の求め、開示請求、訂正・追加・削除請求、利用停止・消去請求又は第三者提供の停止請求(以下、総称して「開示等の請求等」といいます。)に対しては、下記1記載の連絡窓口にて対応いたします。また、当社は、お客様のマイページにおいて、会員情報の変更及び確認並びにメールマガジンの配信停止等のご希望に応じることとしております。
    </p>

    <h3>9. 外部へのリンクについて</h3>
    <p>
      LINKTIVITYホームページには、他のサイトへのリンクが含まれています。本プライバシーポリシーは、LINKTIVITYホームページによって収集される情報にだけ適用され、その他のウェブサイトのプライバシーポリシーまたはコンテンツについて、当社は責任を負いません。お客様におかれましては、リンク先の各ウェブサイトで、プライバシーポリシーをお読みいただき、お客様の個人情報の取扱いについてご確認いただきますようお願い申し上げます。
    </p>

    <h3>10. プライバシーポリシーの変更について</h3>
    <p>
      当社は、プライバシーポリシーをLINKTIVITYホームページ上に掲載し、当社がどのようなお客様のどのような個人情報をどのような目的で取得し、利用しているか、お客様が常に知ることができる状態にしています。また、プライバシーポリシーの変更についても、LINKTIVITYホームページ上に掲載し、お客様に公表しております。
    </p>

    <h3>11. 連絡先について</h3>
    <p>
      当社のプライバシーポリシーや、当社の個人情報保護への取り組み、お客様の個人情報の取得、利用等に関するご質問又は開示等の請求等については、下記のお問い合わせフォームをご利用ください。担当者より5営業日以内に返答させていただきます。
      <br />
      リンクティビティ株式会社
      <br />
      〒101-0053 東京都千代田区神田美土代町1番地 住友商事美土代ビル9階
      <br />
      データ保護責任者の連絡先: dpo@linktivity.co.jp
    </p>
    <div className={styles.date}>
      2020年05月01日制定
      <br />
      2022年03月18日改定
    </div>
  </div>
);

export default PrivacyPolicy;
